import { useMemo } from 'react';
import useFetchCRMSearchForTotal from 'FormsUI/api/dataFetchingClient/hooks/useFetchCRMSearchForTotal';
import { FORM_OBJECT_TYPE } from 'FormsUI/components/dashboard/frameworkTable/constants';
const useIsFormsZeroState = () => {
  const {
    data,
    error,
    loading
  } = useFetchCRMSearchForTotal({
    objectTypeId: FORM_OBJECT_TYPE
  });
  const isZeroState = useMemo(() => {
    const noForms = data && !data.total;
    return Boolean(!loading && !error && noForms);
  }, [data, error, loading]);
  return {
    isZeroState,
    loading,
    error
  };
};
export default useIsFormsZeroState;